<template>
  <div class="tables-page">
    <Header />

    <section class="tables-toolbar" aria-label="Table search">
      <label class="tables-topbar__search" for="tables-search">
        <i class="icon_search tables-topbar__icon" aria-hidden="true"></i>
        <input
          id="tables-search"
          type="search"
          class="tables-topbar__input"
          placeholder="Search table or event"
          v-model="search"
          autocomplete="off"
          @input="GetTables"
        />
        <button
          v-if="search"
          type="button"
          class="tables-topbar__clear"
          aria-label="Clear search"
          @click="clearTableSearch"
        >
          <i class="icon_close_alt2" aria-hidden="true"></i>
        </button>
      </label>
    </section>

    <div class="tables-page-body">
      <div class="row m-0">
        <aside class="" id="sidebar_fixed"></aside>

        <CModal
          :hideButton="true"
          ref="cancellationModal"
          Text="Add"
          headerText="Cancel Orders"
          :width="550"
          :height="500"
        >
          <template v-slot:content>
            <div class="row p-3">
              <div class="col-lg-12">
                <table style="width: 100%">
                  <div class="col-lg-12 orderAreacancel scrollbar">
                    <tr v-for="(item, index) in modalData" :key="index">
                      <td class="text-left" v-if="item.dish">
                        <h6 class="text-left padding-top-0px">
                          {{ item.dish.name }}
                        </h6>
                        <span class="text-left secondry-color font-size-8px">
                          Rs.{{ item.amount | price }}
                        </span>
                        <table class="width-100perc">
                          <tbody>
                            <tr
                              v-for="(ingredient, index) in item.ingredients"
                              :key="index"
                              class="secondry-color text-left"
                            >
                              <td width="20px" class="text-right">+</td>
                              <td>Add {{ ingredient.name }}</td>
                            </tr>
                          </tbody>
                        </table>
                      </td>

                      <td
                        class="text-left"
                        v-if="item.product"
                        style="width: 40%"
                      >
                        <h6 class="text-left padding-top-0px">
                          {{ item.product.name }}
                        </h6>
                      </td>

                      <td style="width: 20%" class="text-right">
                        <MenuComponent
                          :buttonText="item.unit.name"
                          classes="btn btnSubmit"
                          @selected="menuHandler($event, item)"
                        />
                      </td>

                      <td style="width: 20%" class="text-right">
                        {{ item.quantity }}
                      </td>

                      <td style="width: 20%">
                        <div class="row justify-content-end">
                          <div
                            class="col-md-12 text-right no-padding-left no-padding-right"
                          >
                            <a
                              v-tooltip.top-center="'Delete'"
                              @click="deleteItem(item)"
                              class="btn btn-default btn-sm"
                              style="font-size: 15px"
                            >
                              <span
                                style="color: black"
                                class="icon_trash_alt"
                              ></span>
                            </a>
                          </div>
                        </div>
                      </td>
                    </tr>

                    <tr v-if="!modalData.length">
                      <td colspan="4" class="text-center NoItemsMessage">
                        No Items
                      </td>
                    </tr>
                  </div>
                </table>
              </div>
            </div>
          </template>
        </CModal>

        <div class="col-lg-12">
          <div class="tables-grid" v-if="loading">
            <div
              class="tables-grid__item"
              v-for="(table, index) in 12"
              :key="`skel-${index}`"
            >
              <Skelton class="stripe buttonArea" />
            </div>
          </div>

          <div class="tables-grid" v-else>
            <div
              class="tables-grid__item"
              v-for="(table, index) in displayTables"
              :key="table.id || index"
            >
              <div
                class="table-card"
                :class="{ 'table-card--merged': isMergedPrimary(table) }"
              >
                  <!-- Header -->
                  <div class="table-card__head">
                    <div class="table-card__head-text">
                      <div
                        class="table-card__title"
                        :class="{ 'table-card__title--merged': isMergedPrimary(table) }"
                      >
                        {{ tableDisplayName(table) }}
                      </div>
                      <div class="table-card__subtitle">
                        <template v-if="table.is_event">
                          {{ table.event_date | formatDate }}
                        </template>
                        <template v-else-if="isMergedPrimary(table)">
                          Merged tables · {{ table.type }}
                        </template>
                        <template v-else>
                          {{ table.type }}
                        </template>
                      </div>
                    </div>

                    <!-- Live / Event -->
                    <div class="table-card__status">
                      <div
                        v-if="table.is_order && table.order.items.length > 0"
                        class="live-indicator"
                        title="Order in progress"
                      >
                        <span class="dot"></span>
                        <span class="text">Live</span>
                      </div>
                      <div
                        v-else-if="table.is_event"
                        class="chip chip-event"
                        title="Event"
                      >
                        <i class="icon_calendar"></i>
                        <span>Event</span>
                      </div>
                    </div>
                  </div>

                  <div
                    v-if="tableWaiterName(table)"
                    class="table-card__body"
                  >
                    <div class="table-card__waiter">
                      <span class="table-card__waiter-icon" aria-hidden="true">
                        <i class="icon_profile"></i>
                      </span>
                      <div class="table-card__waiter-text">
                        <span class="table-card__waiter-label">Waiter</span>
                        <span class="table-card__waiter-name">
                          {{ tableWaiterName(table) }}
                        </span>
                      </div>
                    </div>
                  </div>

                  <!-- Actions -->
                  <div class="table-card__actions">
                    <div
                      :class="[
                        'actions-grid',
                        {
                          'has-order':
                            table.is_order && table.order.items.length > 0,
                        },
                      ]"
                    >
                      <!-- Non-event checkout -->
                      <button
                        v-if="
                          table.is_order &&
                          !table.is_event &&
                          table.order.items.length > 0
                        "
                        @click="
                          $router.push('checkout/order/' + table.order.id)
                        "
                        class="btnCheckout1"
                      >
                        <i class="icon_bag"></i>
                        Checkout
                      </button>

                      <!-- Event checkout -->
                      <button
                        v-if="
                          table.is_order &&
                          table.is_event &&
                          table.order.items.length > 0
                        "
                        @click="
                          $router.push('checkout-event/order/' + table.order.id)
                        "
                        class="btnCheckout1"
                      >
                        <i class="icon_bag"></i>
                        Checkout
                      </button>

                      <!-- Add Order -->
                      <button
                        @click="clickToFoodOrder(table.id, table.order)"
                        class="btnCheckout2"
                      >
                        <i class="icon_cart"></i>
                        Add Order
                      </button>

                      <!-- In Order -->
                      <button
                        v-if="table.is_order && table.order.items.length > 0"
                        class="btnCheckout3"
                        @click="showOrders(table)"
                      >
                        <i class="icon_tag"></i>
                        In Order
                      </button>
                    </div>
                  </div>
              </div>
            </div>
          </div>

          <button
            id="chat-circle"
            class="btn-raised"
            v-if="visiblecheckoutclick"
            @click="PopupCheckoutdetails"
          >
            <b><b-icon class="icon_cart_alt"></b-icon></b>
          </button>

          <div id="chat-circle1" class="btn-raised" v-if="visiblecheckout">
                <div>
                  <div class="row">
                    <div class="col-lg-10"></div>
                    <div class="col-lg-2">
                      <button @click="closeOrderShow" class="closeorderbutton">
                        <i class="icon_close_alt2"></i>
                      </button>
                    </div>
                  </div>
                  <h4>{{ orderedItem.order.order_number }}</h4>
                  <p>
                    {{ orderedItem.order.date | formatDate }}
                    {{ orderedItem.order.date | formatTime }}
                  </p>

                  <table style="width: 100%">
                    <div class="orderArea scrollbar">
                      <tr
                        v-for="(item, index) in orderedItem.order.items"
                        :key="index"
                      >
                        <td class="text-left" v-if="item.dish">
                          <h6 class="text-left padding-top-0px">
                            {{ item.dish.name }}
                            <span
                              v-if="item.unit.name != 'item'"
                              class="text-left secondry-color font-size-8px"
                            >
                              ({{ item.unit.name }})
                            </span>
                          </h6>

                          <table class="width-100perc">
                            <tbody>
                              <tr
                                v-for="(ingredient, index) in item.ingredients"
                                :key="index"
                                class="secondry-color text-left"
                              >
                                <td width="20px" class="text-right">+</td>
                                <td>Add {{ ingredient.name }}</td>
                              </tr>
                            </tbody>
                          </table>
                        </td>
                        <td class="text-left" v-if="item.product">
                          <h6 class="text-left padding-top-0px">
                            {{ item.product.name }}
                          </h6>
                        </td>

                        <td class="text-right">
                          {{ item.quantity }}
                        </td>
                      </tr>
                    </div>
                  </table>

                  <b-row>
                    <b-col>
                      <a
                        class="btn_1 btn_scroll fixedbutton1"
                        @click="
                          $router.push('checkout/order/' + orderedItem.order.id)
                        "
                        v-if="orderedItem.is_order && !orderedItem.is_event"
                        >Checkout</a
                      >
                      <a
                        class="btn_1 btn_scroll fixedbutton1"
                        @click="
                          $router.push(
                            'checkout-event/order/' + orderedItem.order.id
                          )
                        "
                        v-if="orderedItem.is_order && orderedItem.is_event"
                        >Checkout</a
                      >

                      <a
                        @click="openModal(orderedItem)"
                        class="ml-4 btn_2 btn_scroll fixedbutton"
                        >Cancel Orders</a
                      >
                    </b-col>
                  </b-row>
                </div>
              </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  MenuComponent,
  PlusMinusInput,
  CustomModal as CModal,
  Skelton,
} from "@/components/base/index.js";

const MyComponent = {
  template: `
    <span class="my-icon">{{ opened ? 'I am open' : ' I am closed' }}</span>
  `,
  props: {
    opened: { type: Boolean, default: false },
  },
};

import VueRangeSlider from "vue-range-component";
import "vue-range-component/dist/vue-range-slider.css";
import axios from "@/plugins/axios";
import { Header } from "@/components/index.js";
import { RefreshButton } from "@/components/index.js";
import { mapState } from "vuex";
import { getBrandSliderStyles } from "@/utils/kotTheme";
import { isTableLockedToOtherWaiter } from "@/utils/permissions";

export default {
  name: "Home",
  data() {
    return {
      search: "",
      loading: false,
      visiblecheckout: false,
      visiblecheckoutclick: false,
      orderId: "",
      selected: { key: "1", text: "select" },
      iconComponent: MyComponent,
      typesLoaded: false,
      Tables: [],
      orderedItem: [],
      Order: Object(),
      range: 0,
      modalData: {},
    };
  },
  computed: {
    ...mapState("sitesetting", ["setting"]),
    displayTables() {
      return (this.Tables || []).filter((table) => !table.is_merged_secondary);
    },
    processStyle() {
      return getBrandSliderStyles(this.setting && this.setting.theme_primary_color).processStyle;
    },
    tooltipStyle() {
      return getBrandSliderStyles(this.setting && this.setting.theme_primary_color).tooltipStyle;
    },
  },
  components: {
    VueRangeSlider,
    MenuComponent,
    Header,
    CModal,
    PlusMinusInput,
    RefreshButton,
    Skelton,
  },
  methods: {
    showOrders(items) {
      this.orderedItem = items;
      setTimeout(() => {
        this.visiblecheckout = true;
        this.visiblecheckoutclick = true;
      }, 50);
    },
    PopupCheckoutdetails() {
      this.visiblecheckout = true;
    },
    closeCheckout() {
      this.visiblecheckout = false;
    },
    closeOrderShow() {
      this.visiblecheckout = false;
    },
    RefreshData() {
      this.GetTables();
    },
    clearTableSearch() {
      this.search = "";
      this.GetTables();
    },
    tableWaiterName(table) {
      if (!table || !table.is_order || !table.order) return "";
      const waiter = table.order.waiter;
      return waiter && waiter.name ? waiter.name : "";
    },
    isMergedPrimary(table) {
      return !!(
        table
        && table.merged_table_names
        && table.merged_table_names.length
      );
    },
    tableDisplayName(table) {
      if (!table) return "";
      if (this.isMergedPrimary(table)) {
        return [table.name, ...table.merged_table_names].join(" + ");
      }
      return table.name;
    },
    clickToFoodOrder(index, items) {
      if (isTableLockedToOtherWaiter(this.$store.state.auth, items)) {
        const name = (items.waiter && items.waiter.name) || "another waiter";
        this.$fire({
          title: "Table locked",
          text: `This table is picked by ${name}.`,
          type: "error",
          timer: 3000,
        });
        return;
      }
      if (items) {
        this.$store.commit("orders/AddGuestDetails", items.guest);
      }
      this.$router.push('/order/table/' + index);
    },
    async GetTables() {
      this.loading = true;
      axios
        .get(`hms/web/tables?&query=${this.search}`)
        .then((res) => {
          this.Tables = res.data;
          this.Tables.map((p) => {
            if (p.order || p.product) {
              p.order.items.map((item) => {
                item.dish.units.map((unit) => {
                  unit.text = unit.name;
                  unit.key = unit.id;
                  return unit;
                });
              });
            }
          });
          this.loaded = true;
        })
        .catch(() => {})
        .then(() => {
          this.loading = false;
        });
    },
    openModal(item) {
      this.modalData = item.order.items;
      this.orderId = item.order.id;
      this.$refs.cancellationModal.show();
    },
    CountChange(event, dish) {
      dish.quantity = event;
      let selectedUnit = dish.dish.units.find((p) => p.key == dish.unit.id);
      if (selectedUnit) {
        dish.amount =
          parseFloat(selectedUnit.dish_units.price) * parseFloat(event);
      }
    },
    updateQuantity(quantity) {
      axios
        .patch(`hms/web/orders/${this.orderId}/items/${quantity.id}`, {
          quantity: quantity.quantity,
        })
        .then(() => {});
    },
    deleteItem(item) {
      if (item.dish) {
        axios
          .delete(`hms/web/orders/${this.orderId}/items/${item.id}`)
          .then(() => {
            let index = this.modalData.findIndex((d) => d.id == item.id);
            if (index != -1) this.modalData.splice(index, 1);
          });
      }
      if (item.product) {
        axios
          .delete(`hms/web/orders/${this.orderId}/products/${item.id}`)
          .then(() => {
            let index = this.modalData.findIndex((d) => d.id == item.id);
            if (index != -1) this.modalData.splice(index, 1);
          });
      }
    },
    menuHandler(event, dish) {
      dish.unit = event;
      let selectedUnit = dish.dish.units.find((p) => p.key == event.key);
      if (selectedUnit) {
        dish.amount =
          parseFloat(selectedUnit.dish_units.price) * parseFloat(dish.quantity);
      }
    },
  },
  created() {
    this.GetTables();
  },
  filters: {
    price(value) {
      return parseFloat(value).toFixed(2);
    },
  },
};
</script>

<style lang="scss">
/* Floating order panel */
#chat-circle1 {
  position: fixed;
  bottom: 50px;
  right: 50px;
  background: #ffffff;
  width: 360px;
  height: 375px;
  border-radius: 12px;
  z-index: 9999;
  color: #2e2e38;
  padding: 15px;
  box-shadow: 0 6px 24px rgba(0, 0, 0, 0.08);
}

#chat-circle {
  position: fixed;
  bottom: 100px;
  right: 80px;
  background: #e5e7eb;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  color: #2e2e38;
  outline: none;
  border: none;
  padding: 12px;
  cursor: pointer;
  box-shadow: 0 8px 18px rgba(0, 0, 0, 0.08);
}

/* Scroll areas */
.orderArea {
  height: 25vh;
  width: 100%;
  overflow-x: scroll;
  margin-top: 8px;
}
.orderAreacancel {
  height: 50vh;
  width: 100%;
  overflow-x: scroll;
  margin-top: 10px;
}

/* Floating buttons in checkout view */
.fixedbutton1 {
  position: fixed;
  bottom: 70px;
  right: 62px;
  width: 156px;
}
.fixedbutton {
  position: fixed;
  bottom: 70px;
  width: 156px;
  right: 246px;
}
.closeorderbutton {
  width: 28px;
  height: 28px;
  border: none;
  padding: 3px;
  border-radius: 28px;
}
</style>

<style scoped>
.tables-page {
  padding-top: 60px;
  min-height: 100vh;
  background: #f8fafc;
  text-align: left;
  box-sizing: border-box;
}

.tables-toolbar {
  position: sticky;
  top: 60px;
  z-index: 12;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px 16px;
  background: #f1f5f9;
  border-bottom: 1px solid #e2e8f0;
  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.05);
  box-sizing: border-box;
}

.tables-page-body {
  padding: 12px clamp(12px, 2vw, 20px) 24px;
  width: 100%;
  box-sizing: border-box;
}

.tables-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
  gap: 14px;
  width: 100%;
  align-items: stretch;
}

.tables-grid__item {
  min-width: 0;
  display: flex;
}

.tables-topbar__search {
  position: relative;
  display: block;
  width: 100%;
  max-width: 520px;
  margin: 0;
}

.tables-topbar__icon {
  position: absolute;
  left: 14px;
  top: 50%;
  transform: translateY(-50%);
  color: var(--brand-primary);
  font-size: 16px;
  pointer-events: none;
  z-index: 1;
}

.tables-topbar__input {
  width: 100%;
  height: 40px;
  padding: 0 40px 0 42px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background: #ffffff;
  color: #1e293b;
  font-size: 14px;
  font-weight: 500;
  line-height: 40px;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.05);
  outline: none;
  box-sizing: border-box;
  -webkit-appearance: none;
  appearance: none;
}

.tables-topbar__input::placeholder {
  color: #94a3b8;
}

.tables-topbar__input:focus {
  border-color: var(--brand-primary);
  box-shadow: 0 0 0 2px var(--brand-primary-fade-20);
}

.tables-topbar__clear {
  position: absolute;
  right: 6px;
  top: 50%;
  transform: translateY(-50%);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  padding: 0;
  border: none;
  border-radius: 50%;
  background: #eef2f7;
  color: #64748b;
  cursor: pointer;
  transition: background 0.15s, color 0.15s;
}

.tables-topbar__clear:hover {
  background: #e2e8f0;
  color: #334155;
}

.tables-topbar__clear i {
  font-size: 12px;
}

@media (max-width: 991px) {
  .tables-topbar__search {
    max-width: 100%;
  }

  .tables-topbar__input {
    font-size: 13px;
  }
}

/* Card — mostly white; theme as thin accent only */
.table-card {
  background: #ffffff;
  border-radius: 14px;
  border: 1px solid #e2e8f0;
  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.06);
  margin: 0;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  min-height: 0;
}

.table-card__head-text {
  min-width: 0;
  flex: 1 1 auto;
}

/* Header */
.table-card__head {
  background: #ffffff;
  color: #1e293b;
  padding: 12px 14px;
  min-height: 64px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  box-sizing: border-box;
  border-bottom: 1px solid #f1f5f9;
  border-top: 3px solid var(--brand-primary);
}
.table-card__title--merged {
  white-space: normal;
  line-height: 1.25;
}

.table-card--merged .table-card__head {
  border-top-color: #7c3aed;
}

.table-card__title {
  font-size: 15px;
  font-weight: 800;
  letter-spacing: 0.02em;
  line-height: 1.2;
  color: var(--brand-primary-dark);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.table-card__subtitle {
  font-size: 11px;
  color: #64748b;
  margin-top: 2px;
  line-height: 1.2;
}

/* Live/Event chips */
.table-card__status {
  display: flex;
  align-items: center;
  gap: 8px;
}
.live-indicator {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 5px 10px;
  border-radius: 999px;
  background: var(--brand-primary-muted);
  color: var(--brand-primary-dark);
  font-weight: 700;
  font-size: 11px;
  border: 1px solid var(--brand-primary-border);
  flex-shrink: 0;
}
.live-indicator .dot {
  position: relative;
  width: 8px;
  height: 8px;
  border-radius: 999px;
  background: var(--brand-primary);
}
.live-indicator .dot::before {
  content: "";
  position: absolute;
  inset: -6px;
  border-radius: inherit;
  border: 2px solid var(--brand-primary);
  opacity: 0.45;
  animation: live-pulse 1.4s ease-out infinite;
}
@keyframes live-pulse {
  0% {
    transform: scale(0.4);
    opacity: 0.9;
  }
  70% {
    transform: scale(1.5);
    opacity: 0;
  }
  100% {
    transform: scale(1.5);
    opacity: 0;
  }
}
.chip {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 5px 10px;
  border-radius: 999px;
  font-size: 11px;
  font-weight: 700;
  background: #f8fafc;
  color: #64748b;
  border: 1px solid #e2e8f0;
  flex-shrink: 0;
}

.chip-event i {
  opacity: 0.95;
}

/* Waiter info */
.table-card__body {
  flex: 1 1 auto;
  display: flex;
  align-items: center;
  padding: 10px 14px;
  min-height: 52px;
  border-bottom: 1px solid #f1f5f9;
  box-sizing: border-box;
}

.table-card__waiter {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  min-width: 0;
}

.table-card__waiter-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: var(--brand-primary-muted);
  color: var(--brand-primary-dark);
  flex-shrink: 0;
}

.table-card__waiter-icon i {
  font-size: 14px;
  line-height: 1;
}

.table-card__waiter-text {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
}

.table-card__waiter-label {
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: #94a3b8;
  line-height: 1.1;
}

.table-card__waiter-name {
  font-size: 13px;
  font-weight: 700;
  color: #334155;
  line-height: 1.2;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* Actions section */
.table-card__actions {
  background: #ffffff;
  padding: 10px;
  border-top: none;
  margin-top: auto;
}

.actions-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 6px;
}

/* With active order: Checkout full width, then Add Order + In Order */
.actions-grid.has-order {
  grid-template-columns: 1fr 1fr;
  gap: 6px;
}

.actions-grid.has-order .btnCheckout1 {
  grid-column: 1 / -1;
}

.btnCheckout1,
.btnCheckout2,
.btnCheckout3 {
  min-width: 0;
  width: 100%;
  height: 38px;
  border-radius: 10px;
  font-weight: 700;
  font-size: 11px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
  padding: 0 8px;
  line-height: 1.15;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  box-sizing: border-box;
  box-shadow: none;
  cursor: pointer;
  transition: background 0.15s ease, border-color 0.15s ease, color 0.15s ease;
}

.btnCheckout1 span,
.btnCheckout2 span,
.btnCheckout3 span {
  overflow: hidden;
  text-overflow: ellipsis;
}

.btnCheckout1 i,
.btnCheckout2 i,
.btnCheckout3 i {
  font-size: 12px;
  flex-shrink: 0;
}

/* Outlined actions — solid fill only on primary hover */
.btnCheckout1,
.btnCheckout2,
.btnCheckout3 {
  background: #ffffff;
  color: var(--brand-primary-dark) !important;
  border: 1px solid var(--brand-primary-border);
}

.btnCheckout1:hover,
.btnCheckout2:hover,
.btnCheckout3:hover {
  background: var(--brand-primary-muted);
  border-color: var(--brand-primary);
  color: var(--brand-primary-dark) !important;
}

/* Checkout: slightly stronger outline (still white) */
.btnCheckout1 {
  border-width: 1.5px;
  border-color: var(--brand-primary);
  font-weight: 800;
}

@media (max-width: 640px) {
  .tables-grid {
    grid-template-columns: 1fr;
    gap: 12px;
  }

  .actions-grid.has-order {
    grid-template-columns: 1fr;
  }

  .actions-grid.has-order .btnCheckout1 {
    grid-column: auto;
  }
}

@media (min-width: 1200px) {
  .tables-grid {
    grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));
  }
}
</style>
